import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  width: 100%;

  margin-bottom: 15px;

  .Mui-disabled {
    -webkit-text-fill-color: rgb(0 0 0) !important;
  }
`;
